// imports
import { Buffer } from 'buffer';
import React from 'react';
import { Provider } from 'react-redux';
import ReactDOM from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import { publicProvider } from 'wagmi/providers/public';
import { getDefaultConfig, ConnectKitProvider } from 'connectkit';
import { createConfig, configureChains, WagmiConfig } from 'wagmi';

import 'bootstrap/dist/js/bootstrap.min';
import './assets/stylesheets/index.scss';
import App from './pages/app';
import Store from './repositories/store';
import reportWebVitals from './reportWebVitals';
import { L1Chain, L2Chain } from './repositories/web3/wagmi/chains';

// interfaces / types / consts
const APP_NAME = 'Skyborne Genesis';
window.Buffer = Buffer;
const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
const { chains, publicClient, webSocketPublicClient } = configureChains([L1Chain, L2Chain], [publicProvider()]);
const config = createConfig(getDefaultConfig({
  chains,
  appName: APP_NAME,
  autoConnect: true,
  walletConnectProjectId: process.env.REACT_APP_WALLET_CONNECT_PROJECT_ID || '',
  publicClient,
  webSocketPublicClient
}));

root.render(
  <React.StrictMode>
    <Provider store={Store}>
      <HelmetProvider>
        <WagmiConfig config={config}>
          <ConnectKitProvider mode="light"><App /></ConnectKitProvider>
        </WagmiConfig>
      </HelmetProvider>
    </Provider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
